export enum Contract {
  TERMS_OF_SERVICE = "terms_of_service",
  PRIVACY_POLICY = "privacy_policy",
  REFERRAL_PROGRAM = "referral_program",
}
